export default "__VITE_ASSET__DijjwF_P__"